export const cancellationStatuses = [
  { id: 'cancellation_received', name: 'Cancellation received' },
  { id: 'cancellation_pending', name: 'Cancellation pending' },
  { id: 'cancellation_completed', name: 'Cancellation completed' },
];
